/**
 * News Archive – custom category tabs → FacetWP checkboxes bridge
 *
 * Custom tab buttons trigger the hidden FacetWP checkbox facet.
 * On FacetWP refresh (facetwp-loaded), tab active states are synced
 * to match whichever checkboxes are currently checked.
 */
export function initNewsArchiveTabs() {
    const tabsNav = document.querySelector('.news-archive__tabs');
    if (!tabsNav) return;

    const tabs = tabsNav.querySelectorAll('.news-archive__tab');

    // Click handler: toggle FacetWP checkbox
    tabs.forEach(tab => {
        tab.addEventListener('click', () => {
            const slug = tab.dataset.slug;
            // Find the matching hidden FacetWP checkbox
            const checkbox = document.querySelector(
                `.news-archive__facet-hidden .facetwp-checkbox[data-value="${slug}"]`
            );
            if (checkbox) {
                checkbox.click(); // FacetWP handles the rest (triggers refresh)
            }
        });
    });

    // Sync tab active states after FacetWP refreshes
    function syncTabs() {
        tabs.forEach(tab => {
            const slug = tab.dataset.slug;
            const checkbox = document.querySelector(
                `.news-archive__facet-hidden .facetwp-checkbox[data-value="${slug}"]`
            );
            if (checkbox && checkbox.classList.contains('checked')) {
                tab.classList.add('is-active');
            } else {
                tab.classList.remove('is-active');
            }
        });
    }

    // FacetWP fires this event after every AJAX refresh
    document.addEventListener('facetwp-loaded', syncTabs);

    // Initial sync on page load
    syncTabs();
}
